export const instaCellTpl = () => {
    return `<li class="col-12 col-md-6 col-lg-3 my-2">
        <a class="d-block" href="#"><div class="bg-img aspect-ratio--box"></div></a>
    </li>`
}